import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  getGameHistory,
  resetGameCoin,
} from "../../../store/GameHistory/action";
import { Link } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DateRangePicker } from "react-date-range";
import dayjs from "dayjs";
import $ from "jquery";
import Pagination from "../../../pages/Pagination";
import Diamond from "../../../assets/images/diamond.png";

const TeenPatti = () => {
  const { gameHistory, total, adminCoin } = useSelector(
    (state) => state.gameHistory,
  );
  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [date, setDate] = useState([
    {
      startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1), // First day of current month
      endDate: new Date(), // Current date
      key: "selection",
    },
  ]);
  const [sDate, setsDate] = useState(
    dayjs(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format(
      "YYYY-MM-DD",
    ),
  );
  const [eDate, seteDate] = useState(dayjs(new Date()).format("YYYY-MM-DD"));
  const [type, setType] = useState("TeenPatti");

  const [activePage, setActivePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    dispatch(getGameHistory(activePage, rowsPerPage, sDate, eDate));
  }, [dispatch, activePage, rowsPerPage, sDate, eDate]);

  useEffect(() => {
    setData(gameHistory);
  }, [gameHistory]);

  useEffect(() => {
    $("#card").click(() => {
      $("#datePicker");
    });
  }, []);

  useEffect(() => {
    if (date.length === 0) {
      setDate([
        {
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
        },
      ]);
    }
    $("#datePicker");
    setData(gameHistory);
  }, [date, gameHistory]);

  const getAllUser = () => {
    setActivePage(1);
    setsDate("ALL");
    seteDate("ALL");
    $("#datePicker");
    dispatch(getGameHistory(activePage, rowsPerPage, sDate, eDate));
  };

  const collapsedDatePicker = () => {
    $("#datePicker").toggleClass("collapse");
  };

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setActivePage(1);
    setRowsPerPage(value);
  };

  const handleResetCoin = () => {
    dispatch(resetGameCoin());
  };

  const handleDateChange = (item) => {
    setDate([item.selection]);
  };

  const applyDateFilter = () => {
    const dayStart = dayjs(date[0].startDate).format("YYYY-MM-DD");
    const dayEnd = dayjs(date[0].endDate).format("YYYY-MM-DD");
    setActivePage(1);
    setsDate(dayStart);
    seteDate(dayEnd);
    dispatch(getGameHistory(activePage, rowsPerPage, dayStart, dayEnd));

    // Manually toggle the collapse class to close the date picker
    const datePicker = document.getElementById("datePicker");
    if (datePicker.classList.contains("show")) {
      datePicker.classList.remove("show");
    }
  };

  return (
    <>
      {/* ── FILTER BAR ── */}
      <div className="row mb-3">
        <div className="col-12">
          <div className="filter-bar">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
              {/* Left — buttons */}
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <button
                  className="btn btn-sm"
                  style={{
                    background: "#1a1f2e",
                    color: "#c8cfe0",
                    border: "1px solid #2a3050",
                    borderRadius: 6,
                  }}
                  onClick={handleResetCoin}
                >
                  Reset Diamond
                </button>
                <button
                  className="edit-btn"
                  style={{ marginRight: 5 }}
                  onClick={getAllUser}
                >
                  All
                </button>
                <button
                  className="edit-btn collapsed"
                  value="check"
                  data-toggle="collapse"
                  data-target="#datePicker"
                  onClick={collapsedDatePicker}
                >
                  Analytics
                  <ExpandMoreIcon style={{ fontSize: 18, marginLeft: 4 }} />
                </button>
                <p style={{ paddingLeft: 10 }} className="my-2 text-secondary">
                  {sDate !== "ALL" && sDate + " to " + eDate}
                </p>
              </div>

              {/* Right — Admin Total Diamonds */}
              <div className="d-flex align-items-center">
                <span style={{ color: "#9CA3AF", fontSize: 13 }}>
                  Admin Total Diamonds :
                  <span style={{ color: "#6ea8fe" }}>
                    &nbsp;&nbsp;{adminCoin}
                  </span>
                </span>
              </div>
            </div>

            {/* Date picker */}
            <div
              id="datePicker"
              className="collapse mt-3"
              aria-expanded="false"
            >
              <div className="container table-responsive">
                <div key={JSON.stringify(date)}>
                  <DateRangePicker
                    onChange={handleDateChange}
                    showSelectionPreview={true}
                    moveRangeOnFirstSelection={false}
                    ranges={date}
                    direction="horizontal"
                  />
                  <div className="mt-3">
                    <button className="edit-btn" onClick={applyDateFilter}>
                      Apply Filter
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── TABLE CARD ── */}
      <div className="row mt-4">
        <div className="col">
          <div className="table-card" id="card">
            <div className="table-card-body">
              <div style={{ overflowX: "auto", width: "100%" }}>
                <table className="table" style={{ borderCollapse: "collapse" }}>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Admin Diamond</th>
                      <th>Win/Lose</th>
                      <th>winner Diamond Minus</th>
                      <th>Total Add Diamond</th>
                      <th>Date</th>
                      <th>Time</th>
                      <th>Info</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.length > 0 ? (
                      data?.map((data, index) => {
                        var gameDate = data?.date ? data?.date.split(",") : [];
                        return (
                          <>
                            <tr
                              data-toggle="collapse"
                              data-target={`#demo${index}`}
                              className="accordion-toggle pointer-cursor"
                            >
                              <td>{index + 1}</td>
                              <td className="text-success">
                                <img
                                  src={Diamond}
                                  width="15"
                                  height="15"
                                  style={{
                                    verticalAlign: "middle",
                                    marginRight: "1px",
                                  }}
                                />
                                {data?.updatedAdminCoin}
                              </td>
                              <td
                                className={
                                  data?.totalAdd + data?.winnerCoinMinus > 0
                                    ? "text-success"
                                    : "text-danger"
                                }
                              >
                                {data?.totalAdd + data?.winnerCoinMinus > 0
                                  ? data?.totalAdd + data?.winnerCoinMinus
                                  : Math.abs(
                                      data?.totalAdd + data?.winnerCoinMinus,
                                    )}
                              </td>
                              <td className="text-danger">
                                <img
                                  src={Diamond}
                                  width="15"
                                  height="15"
                                  style={{
                                    verticalAlign: "middle",
                                    marginRight: "1px",
                                  }}
                                />
                                {parseInt(data?.winnerCoinMinus)}
                              </td>
                              <td className="text-warning">
                                <img
                                  src={Diamond}
                                  width="15"
                                  height="15"
                                  style={{
                                    verticalAlign: "middle",
                                    marginRight: "1px",
                                  }}
                                />
                                {data?.totalAdd}
                              </td>
                              <td className="text-info">{gameDate[0]}</td>
                              <td className="text-primary">{gameDate[1]}</td>
                              <td className="pointer-cursor">
                                <i className="fas fa-info-circle fa-lg"></i>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="8" className="hiddenRow">
                                <div
                                  id={`demo${index}`}
                                  className="accordian-body collapse"
                                >
                                  <h6 className="text-danger">Frame History</h6>
                                  <table className="w-100">
                                    <thead>
                                      <tr>
                                        <th>No</th>
                                        <th>select Frame</th>
                                        <th>bit</th>
                                        <th>card</th>
                                      </tr>
                                    </thead>
                                    <tbody
                                      style={{
                                        maxHeight: 100,
                                        overflowY: "auto",
                                      }}
                                    >
                                      {data?.cardCoin?.length > 0 ? (
                                        data?.cardCoin.map((report, no) => (
                                          <tr key={no} className="border-top">
                                            <td
                                              className={`${report?.winner ? "text-success" : "text-danger"} fw-bold`}
                                            >
                                              {no + 1}
                                            </td>
                                            <td
                                              className={`${report?.winner ? "text-success" : "text-danger"} fw-bold`}
                                            >
                                              {report?.selectFrame}
                                            </td>
                                            <td
                                              className={`${report?.winner ? "text-success" : "text-danger"} fw-bold`}
                                            >
                                              {report?.bit}
                                            </td>
                                            <td
                                              className={`${report?.winner ? "text-success" : "text-danger"} fw-bold`}
                                            >
                                              {report?.card}
                                            </td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td colSpan="7" align="center">
                                            Nothing to show!!
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          </>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="7" align="center">
                          Nothing to show!!
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <Pagination
                activePage={activePage}
                rowsPerPage={rowsPerPage}
                userTotal={total}
                handleRowsPerPage={handleRowsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TeenPatti;
